import { atom, useSetAtom } from 'jotai';

/**
 * Whether the Get Matched questionnaire is up.
 *
 * One atom, because there is one surface. The brief used to sit behind a
 * desktop-only intro card, which is why opening it once forked on viewport
 * width and needed a guard to close the card if the window crossed the
 * breakpoint beneath it. The questionnaire takes the whole screen at every
 * width and opens the same way everywhere, so none of that applies.
 */
export const getMatchedModalOpenAtom = atom(false);

export const useOpenGetMatchedModal = () => {
    const setOpen = useSetAtom(getMatchedModalOpenAtom);
    return () => setOpen(true);
};
